module.exports = __webpack_public_path__ + "48e014aa845cb84f3e174f7583a18624.png";